import React, { useState } from 'react'
import axios from 'axios'
import { Container, Form, Button, Toast } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const SubmitScreen = () => {

    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState('')
    const [link, setLink] = useState('')
    const [social, setSocial] = useState('')
    const [show, setShow] = useState(false)

    const submitHandler = (e) => {
        e.preventDefault()

        console.log(title, desc, link, social)

        const data = { title, desc, link, social }
        axios.post('https://sheet.best/api/sheets/bf331a68-dbcb-4133-9506-557bca713b87', data)
            .then(response => {
                console.log(response);
                setShow(true)
            })
        setTitle('')
        setDesc('')
        setLink('')
        setSocial('')

    }







    return (
        <>
            <Container className="pt-4 text-center" id='postContainer'>
                <LinkContainer to='/'>
                    <Button id='mdm' className="btn btn-secondary btn-outline-dark shadow-lg">Back</Button></LinkContainer>
                <Container className='justify-content-md-center text-center shadow-lg p-4' style={{ maxWidth: '400px', fontWeight: 'bold' }}>
                    <h3>Submit Post</h3>
                    <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">WittyWeb</strong>

                        </Toast.Header>
                        <Toast.Body>Woah! Your Post has Been Submitted For Review</Toast.Body>
                    </Toast>
                    <Form>
                        <Form.Group controlId='name'>
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type='name'
                                placeholder=''
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            ></Form.Control>
                        </Form.Group>                    <br></br>

                        <Form.Group controlId='desc'>
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                type='name'
                                placeholder=''
                                value={desc}
                                onChange={(e) => setDesc(e.target.value)}
                            ></Form.Control>
                        </Form.Group>                    <br></br>


                        <Form.Group controlId='link'>
                            <Form.Label>Link</Form.Label>
                            <Form.Control
                                type='name'
                                placeholder=''
                                value={link}
                                onChange={(e) => setLink(e.target.value)}
                            ></Form.Control>
                        </Form.Group>                    <br></br>

                        <Form.Group controlId='social'>
                            <Form.Label>SocialHandle if any..</Form.Label>
                            <Form.Control
                                type='name'
                                placeholder=''
                                value={social}
                                onChange={(e) => setSocial(e.target.value)}
                            ></Form.Control>
                        </Form.Group>

                        <br></br>
                        <Button onClick={submitHandler} disabled={(title === '' || desc === '' || link === '' || social === '')} className="btn btn-secondary btn-outline-dark" style={{ borderRadius: '0.5em', fontWeight: '600' }}>Submit</Button>
                    </Form>




                </Container>
            </Container>



        </>
    )
}

export default SubmitScreen
